module.exports = __webpack_public_path__ + "static/media/address.2ab6d984.svg";